(function($, Drupal) {
  Drupal.behaviors.bokaBlogPostsModalUnique = {
    attach(context) {
      once(
        "bokaBlogPostsModalUnique",
        ".paragraph--type--blog-posts",
        context
      ).forEach((paragraph, index) => {
        const $paragraph = $(paragraph);
        $(".--modal--toggler", $paragraph).each(function() {
          const $element = $(this);
          const attrName = "data-bs-target";
          $element.attr(attrName, `${$element.attr(attrName)}__${index}`);
        });
        $(".--modal--target", $paragraph).each(function() {
          const $element = $(this);
          const attrName = "id";
          $element.attr(attrName, `${$element.attr(attrName)}__${index}`);
        });
      });
    }
  };
})(jQuery, Drupal);
